// extracted by mini-css-extract-plugin
module.exports = {"aside":"Index_aside_2fLqR"};